import {computed} from "vue";

export function useFilterByState(itemsRef, statesRef, field = "shopState") {
  const filteredByState = computed(() => {
    let states = [...(statesRef.value || [])]; // کپی محلی بسازیم

    if (!states.length) return itemsRef.value;

    // منطق New
    if (states.includes("New")) {
      if (!states.includes("New Order")) states.push("New Order");
      if (!states.includes("To Pay")) states.push("To Pay");
      if (!states.includes("Verifying Payment")) states.push("Verifying Payment");
    } else {
      states = states.filter((item) => !["To Pay", "Verifying Payment", "New Order"].includes(item));
    }

    // منطق Delivering
    if (states.includes("Delivering")) {
      if (!states.includes("Preparing")) states.push("Preparing");
    } else {
      states = states.filter((item) => !["Preparing"].includes(item));
    }

    // منطق Canceled
    if (states.includes("Canceled")) {
      if (!states.includes("Cancelled")) states.push("Cancelled");
    } else {
      states = states.filter((item) => !["Cancelled"].includes(item));
    }

    return itemsRef.value.filter((item) =>
      states.includes(item[field])
    );
  });

  return {filteredByState};
}
